module.exports = __webpack_public_path__ + "static/media/default-file-icon.558927c7.svg";